import { forwardRef } from 'react'
import { validateEmail } from '../../lib/formatters'
import { formatPhoneStrict, formatZip, isValidZip } from '../../lib/validators'

function CheckIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 7.5L6 10L11 4" />
    </svg>
  )
}

const RowInput = forwardRef(function RowInput(
  {
    type = 'text',
    error,
    readOnly,
    className,
    ...rest
  },
  ref,
) {
  const baseCls =
    'row-input' +
    (error ? ' has-error' : '') +
    (readOnly ? ' is-readonly' : '') +
    (className ? ' ' + className : '')

  const wrapProps = { className: 'row-input-wrap' }

  let inputEl = null
  let suffix = null

  if (type === 'phone') {
    const { value, onChange, ...inputRest } = rest
    const { formatted: displayValue, isValid } = formatPhoneStrict(value)
    if (isValid) suffix = <CheckIcon />
    inputEl = (
      <input
        ref={ref}
        type="tel"
        inputMode="tel"
        maxLength={14}
        className={baseCls}
        value={displayValue}
        onChange={(e) => {
          const { formatted } = formatPhoneStrict(e.target.value)
          if (onChange) onChange(formatted)
        }}
        readOnly={readOnly}
        data-lpignore="true"
        data-form-type="other"
        {...inputRest}
      />
    )
  } else if (type === 'email') {
    const { value, onChange, ...inputRest } = rest
    const { isValid } = validateEmail(value)
    if (isValid) suffix = <CheckIcon />
    inputEl = (
      <input
        ref={ref}
        type="email"
        inputMode="email"
        className={baseCls}
        value={value || ''}
        onChange={(e) => {
          if (onChange) onChange(e.target.value)
        }}
        readOnly={readOnly}
        data-lpignore="true"
        data-form-type="other"
        {...inputRest}
      />
    )
  } else if (type === 'zip') {
    const { value, onChange, ...inputRest } = rest
    const displayValue = formatZip(value)
    if (isValidZip(displayValue)) suffix = <CheckIcon />
    inputEl = (
      <input
        ref={ref}
        type="text"
        inputMode="numeric"
        autoComplete="postal-code"
        maxLength={10}
        className={baseCls}
        value={displayValue}
        onChange={(e) => {
          const d = e.target.value.replace(/\D/g, '').slice(0, 9)
          if (onChange) onChange(formatZip(d))
        }}
        readOnly={readOnly}
        data-lpignore="true"
        data-form-type="other"
        {...inputRest}
      />
    )
  } else {
    inputEl = (
      <input
        ref={ref}
        type="text"
        className={baseCls}
        readOnly={readOnly}
        data-lpignore="true"
        data-form-type="other"
        {...rest}
      />
    )
  }

  return (
    <span {...wrapProps}>
      {inputEl}
      {suffix && <span className="row-input-suffix">{suffix}</span>}
    </span>
  )
})

export default RowInput
